import { Column } from "data/table.data";
import { convertRegNumber } from "utils/converter";

export const SELECT_BUSINESS_COLS: Column[] = [
  { id: "name", label: "사업자명", sx: { wordBreak: "break-all" } },
  {
    id: "regNumber",
    label: "사업자등록번호",
    sx: { width: 140, whiteSpace: "nowrap" },
    renderer: (data) =>
      data.regNumber ? convertRegNumber(data.regNumber) : "-",
  },
  { id: "incharge", label: "담당자", sx: { width: 90 } },
];
